import { render, staticRenderFns } from "./NewAccountModal.vue?vue&type=template&id=13098504"
import script from "./NewAccountModal.vue?vue&type=script&lang=js"
export * from "./NewAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports